import React, { Suspense } from 'react';
import Alert from 'react-bootstrap/Alert';
import { Helmet } from 'react-helmet-async';
import { useLabels } from '../../hooks/useLabels';

/**
 * Shell for every settings page: terminology-resolved title, optional
 * description, optional warning (danger tools) and Suspense for lazy children.
 * Save buttons/toasts live inside each wrapped component, unchanged.
 */
export default function SettingsSection({ titleKey, descriptionKey, warningKey, children }) {
	const { t } = useLabels();
	return (
		<section className='settings-section'>
			<Helmet>
				<title>{t(titleKey)}</title>
			</Helmet>
			<h1 className='settings-section-title'>{t(titleKey)}</h1>
			{descriptionKey && <p className='settings-section-description'>{t(descriptionKey)}</p>}
			{warningKey && <Alert variant='danger'>{t(warningKey)}</Alert>}
			<Suspense fallback={<div>Cargando...</div>}>{children}</Suspense>
		</section>
	);
}
